import { useSearchParams } from "react-router-dom";

interface AuthFooterProps {
  mode: "signin" | "signup" | "confirmation" | "reset" | "update";
}

export const AuthFooter = ({ mode }: AuthFooterProps) => {
  const [, setSearchParams] = useSearchParams();

  const toggleMode = () => {
    const newMode = mode === "signin" ? "signup" : "signin";
    setSearchParams({ mode: newMode });
  };

  return (
    <div className="text-center space-y-4">
      {mode === "signin" && (
        <button
          onClick={() => setSearchParams({ mode: "reset" })}
          className="text-sm text-gray-600 hover:text-cso-600"
        >
          Forgot your password?
        </button>
      )}
      {(mode === "signin" || mode === "signup") && (
        <div className="text-sm">
          <button
            onClick={toggleMode}
            className="text-gray-600 hover:text-cso-600"
          >
            {mode === "signin" 
              ? "Don't have an account? Sign up" 
              : "Already have an account? Sign in"}
          </button>
        </div>
      )}
      {(mode === "reset" || mode === "update") && (
        <div className="text-sm">
          <button
            onClick={() => setSearchParams({ mode: "signin" })}
            className="text-gray-600 hover:text-cso-600"
          >
            Back to Sign in
          </button>
        </div>
      )}
    </div>
  );
};